import { render, staticRenderFns } from "./PageStats.vue?vue&type=template&id=50262e36"
import script from "./PageStats.vue?vue&type=script&lang=js"
export * from "./PageStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports